import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltActivityLogListItemIconWireframe from './VeltActivityLogListItemIconWireframe/VeltActivityLogListItemIconWireframe';
import VeltActivityLogListItemAvatarWireframe from './VeltActivityLogListItemAvatarWireframe/VeltActivityLogListItemAvatarWireframe';
import VeltActivityLogListItemContentWireframe from './VeltActivityLogListItemContentWireframe/VeltActivityLogListItemContentWireframe';
import VeltActivityLogListItemTimeWireframe from './VeltActivityLogListItemTimeWireframe/VeltActivityLogListItemTimeWireframe';
var VeltActivityLogListItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-activity-log-list-item-wireframe", __assign({}, transformedProps), children));
};
VeltActivityLogListItemWireframe.Icon = VeltActivityLogListItemIconWireframe;
VeltActivityLogListItemWireframe.Avatar = VeltActivityLogListItemAvatarWireframe;
VeltActivityLogListItemWireframe.Content = VeltActivityLogListItemContentWireframe;
VeltActivityLogListItemWireframe.Time = VeltActivityLogListItemTimeWireframe;
export default VeltActivityLogListItemWireframe;
